import './App.css';
import Header from './components/Header/Header'
import IssueList from './components/IssueList/IssueList';

function App() {

  return (
    <div className="App">
      <Header />
      <IssueList />
    </div>
  );
}

export default App;